import { IAclFilter } from "../../store/queries/acl-filter.interface";
import { Category } from "./category.model";
import { isInArray } from "../../../core/util/is-in-array";
import { dictionarySelector, listSelector } from "../query-facade";
import { createSelector } from "reselect";
import { AclFilter } from "../../store/queries/acl-filter";
import { AppConfig } from "../../../app/app.config";

export class CategoryAclFilter<T extends Category> extends AclFilter<Category> implements IAclFilter<T> {

    constructor(protected entityPlural: string) {
        super();
    }

    createSelector(idsSelector: listSelector<string>, entitiesSelector: dictionarySelector<T>): listSelector<T> {
        return createSelector(
            idsSelector,
            entitiesSelector,
            this.activeUserMembershipsByAccount,
            this.isAccountOwnerByAccount,
            (ids, entities, memberships, isAccountOwner) => {
                AppConfig.debugQueries && console.log("CategoryAclFilter executing", entities);
                return ids
                    .map(id => entities[id])
                    .filter(item => {
                        const membership = memberships[item.account];

                        if (!membership) {
                            return;
                        }

                        if (isAccountOwner[item.account] || membership.admin) {
                            return true;
                        }

                        if (!isInArray(item.id, membership[this.entityPlural])) {
                            AppConfig.debugQueries && console.log("category membership %s check failed", this.entityPlural, item, membership);
                            return false;
                        }

                        return true;
                    });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.acl-filter.ts